import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Loading } from '../../common/loading'
import ErrorCustom, { errorTypes } from '../../errors/ErrorCustom'
import { SaveRoute } from '../../layout/SaveRoute'
import { SUBJECT_TYPE } from '../common/constant'
import { ALERT_TYPE_CODE } from './constant'
import { Content } from './Content'
import './i18n'
import { selectIsRedirect404, selectLoading } from './store/slice'
import {
  getAlertDetails,
  getAlertList,
  getCompanyInfo,
  markAsReadAlert,
} from './store/thunk'

const AlertDetail = () => {
  const dispatch = useDispatch()
  const { alertId } = useParams()
  const locale = useSelector((state) => state.i18n.locale)
  const isRedirect404 = useSelector(selectIsRedirect404)
  const isLoading = useSelector(selectLoading('alertDetail'))

  useEffect(() => {
    if (alertId) {
      dispatch(markAsReadAlert({ alertIds: [Number(alertId)] }))
      dispatch(getAlertDetails({ AlertId: alertId }))
        .unwrap()
        .then((res) => {
          const alertListParams = {
            page: 1,
            pageSize: 9999,
          }
          if (res.alertTypeCode === ALERT_TYPE_CODE.MACROECONOMIC.key) {
            alertListParams.subjectType = [SUBJECT_TYPE.MACROECONOMIC.id]
          } else if (res.alertTypeCode === ALERT_TYPE_CODE.INDUSTRY.key) {
            alertListParams.vsicId = res.industry?.vsicId
          } else if (res.organizationId) {
            alertListParams.organizationId = res.organizationId
            dispatch(getCompanyInfo({ OrganizationId: res.organizationId }))
          }
          dispatch(getAlertList(alertListParams))
        })
        .catch(() => {})
    }
  }, [alertId, locale])

  if (isLoading) {
    return <Loading />
  }

  if (isRedirect404) {
    return <ErrorCustom errorType={errorTypes.NOT_FOUND} />
  }

  return (
    <SaveRoute>
      <Content />
    </SaveRoute>
  )
}

export default AlertDetail
